import { breakpoints } from 'hfs-common-ui';
import styled from 'styled-components';
import { mediaQuery, paddings } from '~/styled';

export const Nav = styled.div`
  flex-grow: 1;
  display: flex;
  justify-content: space-between;
`;

export const DesktopRightSideMenu = styled.div`
  flex-grow: 1;
  margin-right: -${paddings.smallPadding};
  display: flex;
  justify-content: space-between;
  min-width: 154px;
  ${mediaQuery.down.l`
     display: none;
  `}
`;

export const MobileRightSideMenu = styled.div`
  @media (min-width: ${breakpoints.l}px) {
    display: none;
  }
`;

export const RightSideMultiMenus = styled.div<{ $isNewMapAndDashboard?: boolean }>`
  display: flex;
  justify-content: space-evenly;
  color: ${({ theme }) => theme.colors.onBackground};
  ul {
    li {
      &:last-child {
        ul {
          padding-top: ${paddings.defaultPadding};
          max-width: 322px;
          li {
            &:first-child {
              height: auto;
            }
          }
        }
      }
    }
  }
`;
